import { render, staticRenderFns } from "./AppointmentApp.vue?vue&type=template&id=d6259976"
import script from "./AppointmentApp.vue?vue&type=script&lang=ts"
export * from "./AppointmentApp.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentApp.vue?vue&type=style&index=0&id=d6259976&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports